/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkMessage } from '../models/BulkMessage';
import type { BulkMessageApiV2RequestDto } from '../models/BulkMessageApiV2RequestDto';
import type { BulkMessageApiV2ResponseDto } from '../models/BulkMessageApiV2ResponseDto';
import type { BulkMessagePriorityMassMessageFilter } from '../models/BulkMessagePriorityMassMessageFilter';
import type { BulkMessageQueryResultSort } from '../models/BulkMessageQueryResultSort';
import type { BulkMessageStatus } from '../models/BulkMessageStatus';
import type { BulkMessageStatusDto } from '../models/BulkMessageStatusDto';
import type { BulkMessageSuspension } from '../models/BulkMessageSuspension';
import type { PageResponseOfBulkMessagesDto } from '../models/PageResponseOfBulkMessagesDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BulkMessagesService {
    /**
     * Update a bulk message
     * Updates a bulk message for the given creator. The following fields can be updated:
     * - `status`: The status of the bulk message. Can be `Pending`, `Running`, `Cancelled` or `Done`.
     * Depending on the status, the bulk message will be sent to the fans or not.
     * Only one bulk message can be `Running` at a time per creator.
     * - `expiresAt`: The time when the bulk message expires.
     * - `messages`: The messages to send to the fans.
     *
     * @returns BulkMessageApiV2ResponseDto The updated bulk message
     * @throws ApiError
     */
    public static updateBulkMessageV2({
        creatorId,
        messageId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The bulk message id
         */
        messageId: number,
        requestBody: BulkMessageApiV2RequestDto,
    }): CancelablePromise<BulkMessageApiV2ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v2/bulk-messages/{creatorId}/{messageId}',
            path: {
                'creatorId': creatorId,
                'messageId': messageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `The user is not authenticated`,
                403: `The user is not authorized to access the resource`,
                404: `The bulk message was not found`,
                409: `There are too many bulk messages running`,
            },
        });
    }
    /**
     * Query bulk messages
     * Queries bulk message depending on the given filters.
     * @returns PageResponseOfBulkMessagesDto The bulk messages matching the filters
     * @throws ApiError
     */
    public static queryBulkMessagesV2({
        creatorId,
        page,
        size = 10,
        sort,
        sortBy,
        status,
        expiresBefore,
        expiresAfter,
        startsBefore,
        startsAfter,
        createdBefore,
        createdAfter,
        priorityMassMessageFilter,
        includeSendCount,
        includeStatistic,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         *   Sorting criteria in the format: property,(asc|desc).
         * Default sort order is ascending.
         * Multiple sort criteria are supported.
         * Default sorting (when includeStatistic=false and includeSendCount=false) is 'createdAt,desc'.
         * Example URL: ?sort=status,asc&sort=createdAt,desc&sort=startsAt&sort=expiresAt,desc.
         *
         */
        sort?: Array<string>,
        /**
         * Custom sorting criteria. Deprecated. Use 'sort' options instead.
         * @deprecated
         */
        sortBy?: BulkMessageQueryResultSort,
        /**
         * Filter by bulk message status
         */
        status?: BulkMessageStatus,
        /**
         * Filters message expiring before the timestamp
         */
        expiresBefore?: string,
        /**
         * Filters message expiring after the timestamp
         */
        expiresAfter?: string,
        /**
         * Filters message starting before the timestamp
         */
        startsBefore?: string,
        /**
         * Filters message starting after the timestamp
         */
        startsAfter?: string,
        /**
         * Filters message created before the timestamp
         */
        createdBefore?: string,
        /**
         * Filters message created after the timestamp
         */
        createdAfter?: string,
        /**
         * Filter for priority mass messages
         */
        priorityMassMessageFilter?: BulkMessagePriorityMassMessageFilter,
        /**
         * Include the number of dispatches of this message (prefer not to include for speed)
         */
        includeSendCount?: boolean,
        /**
         * Include the messages statistic like totalSent, totalReads and so on (prefer not to include for speed)
         */
        includeStatistic?: boolean,
    }): CancelablePromise<PageResponseOfBulkMessagesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/bulk-messages/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'sortBy': sortBy,
                'status': status,
                'expiresBefore': expiresBefore,
                'expiresAfter': expiresAfter,
                'startsBefore': startsBefore,
                'startsAfter': startsAfter,
                'createdBefore': createdBefore,
                'createdAfter': createdAfter,
                'priorityMassMessageFilter': priorityMassMessageFilter,
                'includeSendCount': includeSendCount,
                'includeStatistic': includeStatistic,
            },
            errors: {
                400: `The request was invalid`,
                401: `The user is not authenticated`,
                403: `The user is not authorized to access the resource`,
            },
        });
    }
    /**
     * Create a new bulk message
     * Creates a new bulk message for the given creator.
     * @returns BulkMessageApiV2ResponseDto The bulk message was created
     * @throws ApiError
     */
    public static createBulkMessageV2({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The bulk message to create
         */
        requestBody: BulkMessageApiV2RequestDto,
    }): CancelablePromise<BulkMessageApiV2ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v2/bulk-messages/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request was invalid`,
                401: `The user is not authenticated`,
                403: `The user is not authorized to access the resource`,
                404: `The creator was not found`,
            },
        });
    }
    /**
     * Suspend fan from receiving bulk messages
     * Suspend a fan from receiving bulk messages for the given creator.
     * @returns BulkMessageSuspension The bulk message suspension
     * @throws ApiError
     */
    public static suspendBulkMessage({
        onlyfansId,
        fanId,
        messageId,
        duration,
        browserId,
    }: {
        /**
         * The creator id
         */
        onlyfansId: number,
        /**
         * The fan id
         */
        fanId: number,
        /**
         * The bulk message id
         */
        messageId: number,
        /**
         * The duration in minutes
         */
        duration: number,
        browserId: string,
    }): CancelablePromise<BulkMessageSuspension> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/bulk-messages/{onlyfansId}/{browserId}/suspensions/{messageId}/{fanId}',
            path: {
                'onlyfansId': onlyfansId,
                'fanId': fanId,
                'messageId': messageId,
                'browserId': browserId,
            },
            query: {
                'duration': duration,
            },
            errors: {
                404: `The bulk message was not found`,
            },
        });
    }
    /**
     * Get a bulk message
     * Gets a bulk message for the given creator.
     * @returns BulkMessage The bulk message
     * @throws ApiError
     */
    public static apiGetBulkMessageV2({
        onlyfansId,
        messageId,
        browserId,
    }: {
        /**
         * The creator id
         */
        onlyfansId: number,
        /**
         * The bulk message id
         */
        messageId: number,
        browserId: string,
    }): CancelablePromise<BulkMessage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/bulk-messages/{onlyfansId}/{browserId}/{messageId}',
            path: {
                'onlyfansId': onlyfansId,
                'messageId': messageId,
                'browserId': browserId,
            },
            errors: {
                404: `The bulk message was not found`,
            },
        });
    }
    /**
     * Delete a bulk message
     * Deletes a bulk message for the given creator.
     * @returns void
     * @throws ApiError
     */
    public static deleteBulkMessage({
        onlyfansId,
        messageId,
        browserId,
    }: {
        /**
         * The creator id
         */
        onlyfansId: number,
        /**
         * The bulk message id
         */
        messageId: number,
        browserId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/bulk-messages/{onlyfansId}/{browserId}/{messageId}',
            path: {
                'onlyfansId': onlyfansId,
                'messageId': messageId,
                'browserId': browserId,
            },
            errors: {
                404: `The bulk message was not found`,
            },
        });
    }
    /**
     * Get a bulk message status
     * Gets a bulk message status
     * @returns BulkMessageStatusDto The bulk message status
     * @throws ApiError
     */
    public static getBulkMessageStatus({
        onlyfansId,
        messageId,
        browserId,
    }: {
        /**
         * The creator id
         */
        onlyfansId: number,
        /**
         * The bulk message id
         */
        messageId: number,
        browserId: string,
    }): CancelablePromise<BulkMessageStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/bulk-messages/{onlyfansId}/{browserId}/{messageId}/status',
            path: {
                'onlyfansId': onlyfansId,
                'messageId': messageId,
                'browserId': browserId,
            },
            errors: {
                404: `The bulk message was not found`,
            },
        });
    }
    /**
     * Lists all ready to send messages
     * Lists all the running bulk messages that are allowed to be send
     * @returns string The bulk messages matching the filters
     * @throws ApiError
     */
    public static listReadyBulkMessages({
        onlyfansId,
        browserId,
    }: {
        /**
         * The creator id
         */
        onlyfansId: number,
        /**
         * The browser id
         */
        browserId: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/bulk-messages/{onlyfansId}/{browserId}/ready',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            errors: {
                400: `The request was invalid`,
            },
        });
    }
}
